"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.setWizardData = exports.setSizeAndWidthChoices = exports.setAnswer = exports.wizardsSlice = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _toolkit = require("@reduxjs/toolkit");

var initialState = {
  questions: {},
  steps: {},
  wizards: {},
  data: {}
};
var wizardsSlice = (0, _toolkit.createSlice)({
  name: 'wizards',
  initialState: initialState,
  reducers: {
    /**
     * Set or remove answers.
     *
     * @param {Object} state The redux state.
     * @param {string} action.payload.questionPath A string separated by `.` to denote the path of the question to
     *   answer. Ex: 'thisQuestionId' or 'thisQuestionId.thisSubQuestionId'.
     */
    setAnswer: function setAnswer(state, action) {
      var _action$payload, _action$payload$quest;

      var path = (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : (_action$payload$quest = _action$payload.questionPath) === null || _action$payload$quest === void 0 ? void 0 : _action$payload$quest.split('.');
      var index = 0;
      var question = state.questions;

      while (question && index < path.length) {
        question = question[path[index]];
        index++;
      }

      if (question.isSingleSelect) {
        question.answer = action.payload.answer;
      } else {
        if (question.answers.includes(action.payload.answer)) {
          // eslint-disable-line no-lonely-if
          question.answers = question.answers.filter(function (answer) {
            return answer !== action.payload.answer;
          });
        } else {
          question.answers.push(action.payload.answer);
        }
      }
    },

    /**
     * Sets the gender specific size and width choices and resets any size and width answers.
     *
     * @param {Object} state The redux state.
     * @param {string} action.payload.gender The gender that was selected.
     * @param {string} action.payload.questionId The parent question id of the size/width question.
     */
    setSizeAndWidthChoices: function setSizeAndWidthChoices(state, action) {
      state.questions[action.payload.questionId].sizeQuestion.answers = [];
      state.questions[action.payload.questionId].widthQuestion.answer = '';
      var gender = action.payload.gender.charAt(0).toLowerCase() + action.payload.gender.slice(1).replace(/[^\w\s]/gi, ''); // remove special characters

      state.questions[action.payload.questionId].sizeQuestion.choices = state.questions[action.payload.questionId].sizeQuestion["".concat(gender, "Sizes")];
      state.questions[action.payload.questionId].widthQuestion.choices = state.questions[action.payload.questionId].widthQuestion["".concat(gender, "Widths")];
    },

    /**
     * Hydrates the redux state with the wizard data from Contentful.
     *
     * @param {Object} state The redux state.
     * @param {Object} action.payload The wizard response. Schema in contentfulApi.
     */
    setWizardData: function setWizardData(state, action) {
      var _wizard$sys;

      var wizard = action.payload;
      var id = wizard === null || wizard === void 0 ? void 0 : (_wizard$sys = wizard.sys) === null || _wizard$sys === void 0 ? void 0 : _wizard$sys.id;

      if (id) {
        state.wizards[id] = wizard;
        wizard.stepsCollection.items.forEach(function (step) {
          var _step$sys, _step$sys2, _step$sys3, _step$choicesCollecti;

          switch (step.__typename) {
            case 'SectionStep':
              state.steps[step === null || step === void 0 ? void 0 : (_step$sys = step.sys) === null || _step$sys === void 0 ? void 0 : _step$sys.id] = step;
              break;

            case 'SizeWidthQuestion':
              state.questions[step === null || step === void 0 ? void 0 : (_step$sys2 = step.sys) === null || _step$sys2 === void 0 ? void 0 : _step$sys2.id] = (0, _objectSpread2.default)((0, _objectSpread2.default)({
                answers: []
              }, step), {}, {
                genderQuestion: {
                  answer: step.gendersCollection.items[0].value,
                  choices: step.gendersCollection.items,
                  isSingleSelect: true
                },
                sizeQuestion: {
                  answers: [],
                  choices: step.mensSizes,
                  menSizes: step.mensSizes,
                  title: step.sizeTitle,
                  womenSizes: step.womensSizes
                },
                widthQuestion: {
                  answer: '',
                  choices: step.mensWidthsCollection.items,
                  isSingleSelect: true,
                  menWidths: step.mensWidthsCollection.items,
                  title: step.widthTitle,
                  womenWidths: step.womensWidthsCollection.items
                }
              });
              break;

            default:
              state.questions[step === null || step === void 0 ? void 0 : (_step$sys3 = step.sys) === null || _step$sys3 === void 0 ? void 0 : _step$sys3.id] = (0, _objectSpread2.default)({
                answer: '',
                answers: [],
                choices: step === null || step === void 0 ? void 0 : (_step$choicesCollecti = step.choicesCollection) === null || _step$choicesCollecti === void 0 ? void 0 : _step$choicesCollecti.items
              }, step);
              break;
          }
        });
        state.data = wizard;
      }
    }
  },
  extraReducers: {}
});
exports.wizardsSlice = wizardsSlice;
var _wizardsSlice$actions = wizardsSlice.actions,
    setAnswer = _wizardsSlice$actions.setAnswer,
    setSizeAndWidthChoices = _wizardsSlice$actions.setSizeAndWidthChoices,
    setWizardData = _wizardsSlice$actions.setWizardData; // The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
// export const selectCount = state => state.counter.value;

exports.setWizardData = setWizardData;
exports.setSizeAndWidthChoices = setSizeAndWidthChoices;
exports.setAnswer = setAnswer;
var _default = wizardsSlice.reducer;
exports.default = _default;